import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { JobDescription } from '../model/jobDescription';
import { JobDescriptionSerializer } from '../model/serializer/jobDescription-serializer';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class JobDescriptionService extends ApiService<JobDescription> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job-description',
      new JobDescriptionSerializer());
  }
}
